import { render, staticRenderFns } from "./qid-input.vue?vue&type=template&id=536bfb38&"
import script from "./qid-input.vue?vue&type=script&lang=js&"
export * from "./qid-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hay/htdocs/git/wiki-tools/public_html/qidquery/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536bfb38')) {
      api.createRecord('536bfb38', component.options)
    } else {
      api.reload('536bfb38', component.options)
    }
    module.hot.accept("./qid-input.vue?vue&type=template&id=536bfb38&", function () {
      api.rerender('536bfb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/qid-input.vue"
export default component.exports